import React, { createContext, useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Login from '../features/Login';
import { Groups } from '../groups.enum';

export interface Auth {
  token: string;
  payload: TokenPayload;
  logout: () => void;
}

export interface AuthWrapperProps {
  children: any;
  logoutRoute: string;
}

export interface TokenPayload {
  group: Groups;
  hostId: string;
  iat: number;
}

export const AuthContext: React.Context<Partial<Auth>> = createContext({});

export const AuthWrapper = ({ children, logoutRoute }: AuthWrapperProps) => {
  const [token, setToken] = useState<string | null>(localStorage.getItem('token'));
  const [payload, setPayload] = useState<TokenPayload | undefined>(undefined);
  const history = useHistory();

  const logout = async () => {
    setToken(null);
    localStorage.removeItem('token');
  };

  const onAccessGranted = async (authToken: string) => {
    localStorage.setItem('token', authToken);
    setToken(authToken);
  };

  const decodeToken = useCallback(() => {
    if (!token) return {};
    const data = token.split('.')[1];
    setPayload(JSON.parse(Buffer.from(data, 'base64').toString('utf-8')));
  }, [token]);

  useEffect(() => {
    decodeToken();
  }, [decodeToken]);

  if (!token) return <Login onAccessGranted={onAccessGranted} />;

  return <AuthContext.Provider value={{ token, payload, logout }}>{children}</AuthContext.Provider>;
};
